import type { Order } from '../Order'
import type { IAction } from '../../action/IAction'
import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import { ShippingRate } from '../../shipping/ShippingRate'
import { ShippingBillTo } from '../../shipping/ShippingBillTo'
import { ShippingPackage } from '../../shipping/ShippingPackage'
import type { OrderDeliveryConfirmationEnum } from '../OrderDeliveryConfirmationEnum'
import type { ShippingOptionArgs } from '../../shipping'

export interface IShipOrder extends IAction<Order, ShipOrderArgs> {}

@InputType()
export class ShipOrderArgs extends ActionArgs implements ShippingOptionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => [ShippingPackage])
  packages?: ShippingPackage[]

  @Field(() => ShippingRate)
  rate?: ShippingRate

  @Field(() => ShippingBillTo)
  billTo?: ShippingBillTo

  @Field(() => Date)
  shippingDate?: Date

  @Field(() => Float)
  shippingAmount?: number

  @Field(() => Boolean)
  isManualShippingRate?: boolean

  @Field(() => String)
  deliveryConfirmation?: OrderDeliveryConfirmationEnum

  forceStatusUpdate?: boolean

  @Field(() => Boolean)
  skipCaching?: boolean
}
